import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';

interface Props {
  itemId: string;
}

export const EmptyItem = ({ itemId }: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: itemId });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return <div style={style} ref={setNodeRef} {...attributes} {...listeners} />
}
